import React from 'react';
import { Check, X } from 'lucide-react';

/**
 * Live indicator that turns green when two password fields match,
 * red when they don't. Renders nothing until the user types in `confirm`.
 */
const PasswordMatchIndicator = ({ password, confirm, className = '' }) => {
  if (!confirm) return null;
  const match = password === confirm;
  return (
    <div
      className={`mt-1 flex items-center gap-1.5 text-xs font-medium ${match ? 'text-emerald-600' : 'text-red-600'} ${className}`}
      data-testid="password-match-indicator"
      data-match={match}
    >
      {match ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />}
      <span>{match ? 'Passwords match' : 'Passwords do not match'}</span>
    </div>
  );
};

export default PasswordMatchIndicator;
